export default "__VITE_ASSET__DKQlQ0Sp__"